import React from 'react';
import * as Flags from 'country-flag-icons/react/3x2';

export function CountryFlag({ countryData }) {
  if (!countryData?.iso2_code) {
    return (
      <div className="w-6 h-4 bg-gray-200 rounded-sm flex items-center justify-center">
        <span className="text-xs text-gray-500 font-mono">{countryData?.iso_code || '??'}</span>
      </div>
    );
  }

  const FlagComponent = Flags[countryData.iso2_code];
  if (FlagComponent) {
    return <FlagComponent className="w-6 h-4 rounded-sm shadow-sm" />;
  }

  return (
    <div className="w-6 h-4 bg-gray-200 rounded-sm flex items-center justify-center">
      <span className="text-xs text-gray-500 font-mono">{countryData.iso_code}</span>
    </div>
  );
}
